import React from "react";

const BUSINESS_STATUS = {
  draft:    { label: "Borrador",   cls: "bg-zinc-100 text-zinc-700 border border-zinc-200" },
  pending:  { label: "Pendiente",  cls: "bg-amber-100 text-amber-800 border border-amber-200" },
  approved: { label: "Aprobado",   cls: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
  rejected: { label: "Rechazado",  cls: "bg-rose-100 text-rose-800 border border-rose-200" },
  paused:   { label: "Pausado",    cls: "bg-slate-200 text-slate-700 border border-slate-300" },
  sold:     { label: "Vendido",    cls: "bg-violet-100 text-violet-800 border border-violet-200" },
};

const REQUEST_STATUS = {
  pending:           { label: "Pendiente",          cls: "bg-amber-100 text-amber-800 border border-amber-200" },
  in_review:         { label: "En revisión",        cls: "bg-sky-100 text-sky-800 border border-sky-200" },
  approved:          { label: "Aprobada",           cls: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
  in_conversation:   { label: "En conversación",    cls: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
  meeting_requested: { label: "Reunión solicitada", cls: "bg-violet-100 text-violet-800 border border-violet-200" },
  closed:            { label: "Cerrada",            cls: "bg-slate-200 text-slate-700 border border-slate-300" },
};

const USER_BADGES = {
  super_admin: { label: "Súper admin",   cls: "bg-slate-900 text-amber-400" },
  seller:      { label: "Vendedor",      cls: "bg-amber-100 text-amber-800 border border-amber-200" },
  investor:    { label: "Inversionista", cls: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
};

export default function StatusBadge({ status, type = "business" }) {
  const map = type === "request" ? REQUEST_STATUS : type === "role" ? USER_BADGES : BUSINESS_STATUS;
  const cfg = map[status] || { label: status, cls: "bg-zinc-100 text-zinc-700 border border-zinc-200" };
  return (
    <span data-testid={`status-${status}`} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${cfg.cls}`}>
      {cfg.label}
    </span>
  );
}
